import Vue from 'vue';
import Vuex from 'vuex';
import router from './router';
import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: null,
    loggingIn: false,
    loginError: null
  },
  mutations: {
    loginStart: state => state.loggingIn = true,
    loginStop: (state, errorMessage) => {
      state.loggingIn = false;
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    }
  },
  actions: {
    doLogin({ commit }, loginData) {
      commit('loginStart');
      
      // Check if API endpoint is defined
      if (!process.env.VUE_APP_API_ENDPOINT) {
        console.error('VUE_APP_API_ENDPOINT is not defined in environment variables');
        commit('loginStop', 'API endpoint not configured. Please contact administrator.');
        return;
      }

      // Ensure we have a properly formatted URL by removing trailing slash if it exists
      const baseUrl = process.env.VUE_APP_API_ENDPOINT.endsWith('/') 
        ? process.env.VUE_APP_API_ENDPOINT.slice(0, -1) 
        : process.env.VUE_APP_API_ENDPOINT;
      
      console.log('Login request URL:', `${baseUrl}/admin_login`);
      
      axios.post(`${baseUrl}/admin_login`, {
        ...loginData
      })
      .then(response => {
        if(response.data.success==true){
        localStorage.setItem('accessToken', response.data.user_token);
        localStorage.setItem('partner_name', response.data.user_details[0].admin_name);
        localStorage.setItem('admin_img', response.data.user_details[0].admin_img);
        localStorage.setItem('smtp_email', response.data.user_details[0].smtp_email);
        localStorage.setItem('smtp_password', response.data.user_details[0].smtp_password);
        localStorage.setItem('_id', response.data.user_details[0]._id);
        commit('loginStop', null);
        commit('updateAccessToken', response.data.user_token);
        router.push('/dashboard');
        }else{
          commit('loginStop','Invalid login details');
          commit('updateAccessToken', null);
        }
        
      })
      .catch(error => {
        console.error('Login error details:', error);
        
        let errorMessage = 'Network or server error occurred';
        
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.error('Response error data:', error.response.data);
          console.error('Response error status:', error.response.status);
          console.error('Response error headers:', error.response.headers);
          
          errorMessage = error.response.data && error.response.data.errorMessage 
            ? error.response.data.errorMessage 
            : `Server error: ${error.response.status}`;
        } else if (error.request) {
          // The request was made but no response was received
          console.error('Request error:', error.request);
          errorMessage = 'No response received from server';
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error message:', error.message);
          errorMessage = `Request error: ${error.message}`;
        }
        
        commit('loginStop', errorMessage);
        commit('updateAccessToken', null);
      })
    },
    fetchAccessToken({ commit }) {
      commit('updateAccessToken', localStorage.getItem('accessToken'));
    },
    fetchUserdata({ commit }) {
      commit('UserDetails', localStorage.getItem('UserDetails'));
    },
    logout() {
      localStorage.removeItem('accessToken');
      router.push('/login');
    }
  }
})